import Query from '@arcgis/core/rest/support/Query';
import React, { useEffect, useState } from 'react'

const DataListAutoComplete = ({id,currentLayerId,fieldName,view,queryValue}) => {
  const [options, setOptions] = useState([]);

  useEffect(()=>{
    let layerList=view.map.allLayers.filter(layer=>{
      return layer.id === currentLayerId
    })
    if(layerList.length>0 && fieldName.length>0){
      let layer = layerList.getItemAt(0)
      let query = new Query({
        where:`${fieldName} LIKE '${queryValue}%'`,//text:`${queryValue}`,
        outFields:[`"${fieldName}"`],
        orderByFields:[`"${fieldName}"`],
        num:10,
        returnGeometry:false,
        returnDistinctValues:true

      })
      layer.queryFeatures(query).then((res=>{
        let attributeList=res.features.map((feature=>{
          return feature.attributes[fieldName]
        }))
        setOptions(attributeList)
      }))
    }
    return ()=>{
      setOptions([])
    }

  },[currentLayerId,fieldName,view,queryValue])

  let optionList = options.map(option=>{
    return(
      <option key={option} value={option}/>
    )
  })

  return (
    <>
    <datalist id={id}>
    {optionList}
    </datalist>
    </>
  )
}

export default DataListAutoComplete